import * as React from 'react';

import { rem } from '../../styles/rem';
import ministryLogo from './OEMI_DK_Sort.svg';

const LogoFooter = () => (
  <img
    src={ministryLogo}
    alt="Økonomi- og Indenrigsministeriet"
    width="1471"
    height="699"
    sx={{
      display: 'block',
      width: rem(240),
      maxWidth: '100%',
      height: 'auto',
    }}
  />
);

export default LogoFooter;
